import { render, staticRenderFns } from "./ResolutionForm.vue?vue&type=template&id=0b1b1989&scoped=true&"
import script from "./ResolutionForm.vue?vue&type=script&lang=js&"
export * from "./ResolutionForm.vue?vue&type=script&lang=js&"
import style0 from "./ResolutionForm.vue?vue&type=style&index=0&id=0b1b1989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1b1989",
  null
  
)

export default component.exports